export default "__VITE_ASSET__BNlWnwVX__"